<template>
  <el-dialog
    title="导入数据"
    :close-on-click-modal="false"
    :visible.sync="visible"
    width="800px">
    <el-upload
      class="import-excel"
      ref="upload"
      accept=".xls"
      :action="uploadUrl"
      :show-file-list="false"
      :auto-upload="false"
      :multiple="false"
      :data="uploadData"
      :on-success="handleSuccess"
      :before-upload="beforeExcelUpload"
      :on-error="handleError"
      :file-list="fileList"
      :on-change="changeFile">
       <el-input v-model="fileName" :disabled="true" class="import-excel-input" style="width: 560px;"></el-input>
      <el-button style="margin-left: 72px;"  type="primary" icon="el-icon-upload2" :loading="loading" >选取文件</el-button>
    </el-upload>
    <div class="line"></div>
    <el-row>
      <!-- <el-col :span="4">
        <el-button type="primary" icon="el-icon-download" @click="exportHandle">下载模板</el-button>
      </el-col>
      <el-col :span="12"><div style="height: 1px"></div></el-col> -->
      <el-col :span="8">
        <!-- size="small" -->
        <el-button  @click="visible = false" :loading="loading"  style="width: 88px;">取消</el-button>
        <el-button  type="primary" @click="submitUpload" :loading="loading"  style="margin-left: 10px;width: 88px;" >导入</el-button> </el-col>
    </el-row>

    <el-dialog
      title="导入数据"
      :close-on-click-modal="false"
      :visible.sync="hasError"
      append-to-body
      width="800px">
      <el-table
        :data="errorList"
        border
        style="width: 100%;">
        <el-table-column
          type="index"
          :index="indexMethod" label="编号"
          header-align="center"
          align="center"
          width="50">
        </el-table-column>
        <el-table-column
          prop="fieldKey"
          header-align="center"
          align="center"
          show-overflow-tooltip
          label="字段名">
        </el-table-column>
        <el-table-column
          prop="fieldValue"
          header-align="center"
          align="center"
          show-overflow-tooltip
          label="字段值">
        </el-table-column>
        <el-table-column
          prop="errorReason"
          header-align="center"
          align="center"
          label="错误原因">
        </el-table-column>
        <el-table-column
          prop="rowNumber"
          header-align="center"
          align="center"
          show-overflow-tooltip
          label="错误行">
        </el-table-column>
      </el-table>
    </el-dialog>
  </el-dialog>

</template>

<script>
// import Cookies from 'js-cookie'
import mixinViewModule from '@/mixins/view-module'
export default {
  name: 'courseimport',
  mixins: [mixinViewModule],
  data () {
    return {
      // mixinViewModuleOptions: {
      //  getDataListURL: '/sys/courseinfo/list',
      //  getDataListIsPage: true
      // },
      uploadData: [],
      loading: false,
      visible: false,
      fileList: [],
      errorList: [],
      fileName: '',
      uploadUrl: '',
      hasError: false
    }
  },
  props: {
    courseId: {// 课程id
      type: String,
      required: true
    },
    url: {// 文件提交位置
      type: String,
      required: true
    },
    shuttering: {// 模板下载地址
      type: String,
      required: true
    },
    name: { // 模板名称
      type: String,
      default: '导入模板'
    }
  },
  created () {
    //  `${window.SITE_CONFIG['apiURL']}` this.$message(this.courseId + '' + this.url + '---' + '-----' + `${window.SITE_CONFIG['apiURL']}`)

    //this.$message(`${window.SITE_CONFIG['apiURL']}`+'' + this.url + '---' + '-----' + this.courseId + this.uploadData.courseId)
    this.uploadUrl = `${window.SITE_CONFIG['apiURL']}` + this.url + `?token=${this.getStorage(this.GLOBAL.TOKEN)}&courseId=${this.courseId}`
    //this.uploadUrl = 'http://localhost:8001/api' + this.url + `?token=${this.getStorage(this.GLOBAL.TOKEN)}&courseId=${this.courseId}`
    // this.uploadUrl = `${window.SITE_CONFIG['apiURL']}` + this.url + `?token=${this.getStorage(this.GLOBAL.TOKEN)}`
    this.num = 0
    this.fileList = []
    this.visible = true
  },
  methods: {
    indexMethod (index) {
      return index + 1
    },
    beforeExcelUpload (file) {
      // this.uploadData = { courseId: '1', couresid: '33' }
      // this.$message(this.uploadData.courseId)
      console.log(file)
      let maxLength = 2 * 1024 * 1024
      if (file.size > maxLength) {
        this.$message({
          message: '大小不能超过2M',
          type: 'error',
          duration: 1500,
          onClose: () => {
            // this.$emit('refreshDataList')
          }
        })
        this.init()
        this.loading = false
        return false
      }
      var fileName = file.name
      var first = fileName.lastIndexOf('.')// 取到文件名开始到最后一个点的长度
      var namelength = fileName.length // 取到文件名长度
      var filesuffix = fileName.substring(first + 1, namelength)// 截取获得后缀名
      if (filesuffix === 'csv') {
        this.$message({
          message: '只能上传Excel',
          type: 'error',
          duration: 1500,
          onClose: () => {
            // this.$emit('refreshDataList')
          }
        })
        this.init()
        this.loading = false
        return false
      }
      // 校验文件格式
      if (file.type !== 'application/vnd.ms-excel') {
        this.$message({
          message: '只能上传Excel',
          type: 'error',
          duration: 1500,
          onClose: () => {
            // this.init()
            // this.$emit('refreshDataList')
          }
        })
        this.init()
        this.loading = false
        return false
      }
      return true
    },
    init () {
      console.log('1111111')
      this.visible = true
      this.fileName = ''
      this.fileList = []
      this.loading = false
      console.log(this.loading)
    },
    submitUpload () {
      if (this.fileName) {
        this.loading = true
        this.$refs.upload.submit()
        // this.getDataList()
      }
    },
    changeFile (file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
      if (file.status === 'ready') {
        this.fileName = file.name
      }
    },
    handleSuccess (response, file, fileList) {
      console.log(response)
      if (response.code !== '2' && response.data !== null && response.data.length > 0) {
        // this.$message('111' + response)
        this.errorList = response.data
        this.hasError = true
        this.init()
        // this.$emit('refreshDataList')
        return
      }
      if (Number(response.code) < 0) {
        this.$message({
          message: response.msg,
          type: 'error',
          duration: 1500,
          onClose: () => {
            console.log('onClose')
          }
        })
        this.init()
        this.loading = false
        return 0
      }
      if (Number(response.code) === 10002) {
        this.$message({
          message: '请使用正确模板',
          type: 'error',
          duration: 1500,
          onClose: () => {
            // this.init()
            // this.loading = false
          }
        })
        this.init()
        this.loading = false
        return 0
      }
      this.$message({
        message: '操作成功',
        type: 'success',
        duration: 1500
      })
      // this.$message('111' + response.data.filename + response.code)
      this.init()
      this.$emit('filenamelist', response.data)
      this.visible = false
    },
    handleError (err, file, fileList) {
      console.log(err + file + fileList)
      this.loading = false
    },
    // 导出
    exportHandle () {
      // download 参数 url, params, 报表名
      this.$request.download(this.shuttering, this.name)
    }
  }
}
</script>
<style lang='scss' scoped>
  .import-excel .el-upload.el-upload--text {
    float: right;
    margin-right: 37px;
  }
  .import-excel {
    height: 60px;
  }
  .import-excel .import-excel-input .el-input__inner{
    color: black;
  }
</style>
<style lang='scss' scoped>
  .line {
    height: 1px;
    border-top: 1px solid #b2b0b4;
    text-align: center;
    margin: 10px;
  }
</style>
